import React, { useState, useEffect, forwardRef } from "react";
import { Tooltip } from "antd";
import { useDispatch } from "react-redux";
import SectionHeader from "../../components/global/SectionHeader";
import { Spin, notification, Select, Button } from "antd";
import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { useSidebar } from "../../components/provider/Provider";
import Layout from "../../components/global/layout";
import ApiClient from "../../methods/api/apiClient";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { MdOutlineFormatListBulleted } from "react-icons/md";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
const { Option } = Select;

const EmployeeReview = () => {
  const userid = localStorage.getItem("USERID");
  const [array, setArray] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setFrom] = useState({
    employeeId: "",
    projectId: "",
    reviewType: "Code Review",
    description: "",
    addedBy: userid ? userid : "",
  });

  useEffect(() => {
    projectAssign();
  }, []);

  const projectAssign = () => {
    setLoading(true);
    let data = {
      id: userid,
    };
    ApiClient.allApi("user/assignedProjects", data).then((res) => {
      if (res.success) {
        setArray(res.data);
      }else{
        notification.error({
          message: res.message,
        });
      }
      setLoading(false);
    });
  };

  
  

 

  
  const columns = [
    {
      title: "Project Name",
      dataIndex: "name",
      field: "name",
      render: (text, record) => (
        <>
          {text && text?.name ? (
            <Link to={`/projectDetail?id=${text.id}`} className="text-link">
              <Tooltip title="View">
                <span>{text && text.name}</span>
              </Tooltip>
            </Link>
          ) : (
            "--"
          )}
        </>
      ),
    },

    {
        title: "See Project code Reply",
        dataIndex: "name",
        field: "name",
        render: (text, record) => (
          <>
            {text && text?.name ? (
              <Link to={`/reviewsCode/${text.id}`} className="text">
                <Tooltip title="View">
                  <span><MdOutlineFormatListBulleted style={{fontSize: "18px"}}/>
                  </span>
                </Tooltip>
              </Link>
            ) : (
              "--"
            )}
          </>
        ),
      },
    
  ];

  const newlyAddedChapter =
    array && array.length
      ? array.map((items) => {
          return {
            ...items,
          };
        })
      : [];

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  return (
    <Layout>
      <div>
        <div className="main-content">
          <div className="section table table-striped">
            <div className="headings">
              <SectionHeader title="Reviews on your code" />
            </div>
            <Spin spinning={loading}>
              <MaterialTable
                options={{
                  showTitle: false,
                  pageSize: 10,
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  emptyRowsWhenPaging: false,
                }}
                columns={columns}
                data={newlyAddedChapter}
                icons={tableIcons}
              />
            </Spin>
          </div>
        </div>
      </div>

   
    </Layout>
  );
};

export default EmployeeReview;
